import firebase from "../../Firebase";

export default {
    checkOverdraft(clientId) {
        return new Promise((resolve) => {
            firebase
                .instance()
                .firestore()
                .collection("customers")
                .doc(clientId)
                .get()
                .then(doc => {
                    if (doc.exists) {
                        resolve(doc.data().paid);
                    } else {
                        resolve(undefined);
                    }
                })
                .catch(e => {
                    resolve(undefined);
                });
        });
    },
    payOverdraft(clientId, data = null) {
        return new Promise((resolve, reject) => {
            firebase
                .instance()
                .firestore()
                .collection("customers")
                .doc(clientId)
                .set({ paid: data ? data.paid : true })
                .then(doc => {
                    resolve(true);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};
